import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Paper, CircularProgress, Alert, List, ListItem, ListItemText, Divider } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

const StatCard = ({ title, value }) => (
    <Paper sx={{ p: 2, textAlign: 'center', height: '100%' }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="h4" color="primary">{value}</Typography>
    </Paper>
);

function AdminDashboardPage() {
    const { token } = useAuth();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const { data } = await axios.get('/api/admin/stats', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setStats(data);
            } catch (err) {
                setError('Failed to load dashboard statistics.');
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, [token]);

    return (
        <AdminLayout>
            <Typography variant="h4" gutterBottom>Dashboard</Typography>
            {loading && <CircularProgress />}
            {error && <Alert severity="error">{error}</Alert>}
            {stats && (
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={3}><StatCard title="Total Users" value={stats.totalUsers} /></Grid>
                    <Grid item xs={12} sm={6} md={3}><StatCard title="Total Items" value={stats.totalItems} /></Grid>
                    <Grid item xs={12} sm={6} md={3}><StatCard title="Resolved Items" value={stats.resolvedItems} /></Grid>
                    <Grid item xs={12} sm={6} md={3}><StatCard title="Pending Reports" value={stats.totalReports} /></Grid>
                    
                    <Grid item xs={12} md={6}>
                        <Paper sx={{ p: 2 }}>
                            <Typography variant="h6">Recent Users</Typography>
                            <List>
                                {stats.recentUsers.map((user, index) => (
                                    <React.Fragment key={user._id}>
                                        <ListItem>
                                            <ListItemText primary={user.username} secondary={user.email} />
                                        </ListItem>
                                        {index < stats.recentUsers.length - 1 && <Divider />}
                                    </React.Fragment>
                                ))}
                            </List>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper sx={{ p: 2 }}>
                            <Typography variant="h6">Recent Items</Typography>
                            <List>
                                {stats.recentItems.map((item, index) => (
                                    <React.Fragment key={item._id}>
                                        <ListItem>
                                            <ListItemText primary={item.itemName} secondary={`Type: ${item.type}`} />
                                        </ListItem>
                                        {index < stats.recentItems.length - 1 && <Divider />}
                                    </React.Fragment>
                                ))}
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
            )}
        </AdminLayout>
    );
}

export default AdminDashboardPage;
